import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';

@Component({
  selector: 'app-settings-tabs',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './settings-tabs.component.html',
  styleUrl: './settings-tabs.component.scss',
})
export class SettingsTabsComponent implements OnInit, OnDestroy {
  activeSettingsTab: string = 'general';
  private destroy$ = new Subject<void>();

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.checkRoute();
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe(() => this.checkRoute());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkRoute(): void {
    const url = this.router.url;
    if (url.includes('/home/permissions')) {
      this.activeSettingsTab = 'permission';
    } else {
      this.activeSettingsTab = 'general';
    }
  }
}
